
import { Spanish } from "../_Translate/Spanish";
import { English } from "../_Translate/English";

export const HAS__FIELDS_RESOURCE_API = false;

const TRANSLATE = { es: Spanish, en: English };

export const onFieldsContent = (lang = "es") => (TRANSLATE[lang] ?? Spanish).FIELDS;

export const FIELDS_CONTENT = onFieldsContent();
